export default __webpack_public_path__ + "static/media/1807.66939308.png";